import script from "./inputNewDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputNewDate.vue?vue&type=script&setup=true&lang=ts"

import "./inputNewDate.vue?vue&type=style&index=0&id=0742f626&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0742f626"]])

export default __exports__